import React from 'react';
import {IndexLink, Link, withRouter} from 'react-router';
import axios from 'axios';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import Footer2Component from "./footer2";
import FooterComponent from "./footer";

var $ = require('jquery');
var items = [];

var schools;
class Splash_Signup extends React.Component {
    constructor(props) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleESubmit = this.handleESubmit.bind(this);
        this.state = {
            comOps: [],
            tab: 'student',
            user: {
                fname: '',
                lname: '',
                email: '',
                pass: '',
                school: 0,
                disabled: false
            },
            comOpsE: [],
            employer: {
                fname: '',
                lname: '',
                email: '',
                pass: '',
                company: 0,
                name_company: "",
                phone: "",
                disabled: false
            },
            public_job: {}
        };
    }

    componentDidMount() {
        console.log('exampleComponent mounted');
        const api = {api: 'getSchools'};
        $.ajax({
            url: this.props.url,
            dataType: 'json',
            type: 'POST',
            data: api,
            success: function (data) {
                if (data.status == 1) {

                    schools = data.data;
                    items = [];
                    items.push(<option value="0" key="0">
                        Your school
                    </option>);
                    for (var school of data.data) {
                        //console.log(school);
                        items.push(<option value={school.id_university}
                                           key={this.props.keycount + school.id_university}>
                            {school.name_university + " - " + school.city_university + ", " + school.state_university}
                        </option>);
                    }
                    this.forceUpdate();
                    //this.setState(user: {fname:'',lname:'',email:'',pass:'',school:0,disabled:false});
                } else {
                    this.props.openDialog(data.message);
                    //console.log('alert here');
                }


            }.bind(this),
            error: function (xhr, status, err) {
                console.log(xhr.responseText);
                console.error(this.props.url, status, err.toString());

            }.bind(this)
        });

        var tab = this.state.tab
        if (this.props.noSwitch == 1) {
            tab = 'student'
        }
        else if (this.props.noSwitch == 2) {
            tab = 'business'
        }

        this.setState({tab: tab})
    }

    handleChange = (propertyName, event) => {
        const user = this.state.user;
        user[propertyName] = event.target.value;
        this.setState({user: user});
    };

    getCompOptions = (input) => {
        if (input.length == 0 || input.length < 2) {
            this.setState({comOps: this.state.comOps});
        }
        else {
            var data = new FormData();
            data.append('search', input);
            axios.post('/code/apis.php?api=searchSchool', data, {
                progress: (progressEvent) => {
                }
            })
                .then(response => {
                    if (response.data.status == 1) {
                        var array = [];
                        var i = 1;
                        for (var item of response.data.data) {
                            var name = item.name_university;
                            var subname = item.init_university;
                            var active = item.active_university;
                            if (subname) name += " - " + subname;

                            var img = '';
                            if (item.id_file_university > 0) {
                                img = item.file.link_file;
                            }
                            var des = item.city_university;
                            array.push({value: item.id_university, label: name, active: active, des: des, icon: img});
                            i++;
                        }
                        if (array.length == 0) {
                            array.push({value: 0, label: input, active: 0, des: "", icon: ""}); //Add New School https://www.upwork.com/messages/rooms/room_1a867e533331de827abe80413883af2f/story_947e3c423bf984f6e7154c23df1e48d9
                        }

                        this.setState({comOps: array});
                    }
                    return response;
                }).catch(error => {
            });
        }
    }

    optionRenderer = (option) => {
        var img = option.label.substring(0, 1).toUpperCase();
        if (option.icon != "") {
            img = (<img src={option.icon}/>);
        }
        return (
            <div className="option_item">
                <div className="option_img">
                    {img}
                </div>
                <div className="option_label">
                    <span className="name">{option.label}</span><br/>
                    <span className="des">{option.des}</span>
                </div>
            </div>
        );
    }

    onSelectSchool = (item) => {
        var user = this.state.user;
        if (item.value == 0) {
            user.school = 0;
            user.name_school = item.label;
        } else {
            user.school = item.value;
            user.name_school = "";

            if (item.active == 0) {
                this.props.openDialog("Your school has not been activated");
            }
        }
        this.setState({user: user});
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const user = this.state.user;
        user['api'] = this.state.tab === 'educator' ? 'ecsignup' : 'signup';
        user['expert'] = this.props.expert;
        const email = this.state.user.email.trim();
        const pass = this.state.user.pass.trim();
        if (!email || !pass || this.state.user.disabled) {
            return;
        }
        if (this.state.user.school == 0) {
            //this.props.openDialog("Please select your school");
            return;
        }
        var foundschool = false;
        for (var school of schools) {
            if (school.id_university == this.state.user.school) {
                foundschool = true;
                if (".edu" != email.substr(email.length - 4).toLowerCase() && this.state.tab === 'student') {
                    this.props.openDialog("Email must end in .edu if you want to register account for " + school.name_university);
                    return;
                }
                var sufemail = email.split('@');
                if (school.email_suffix_university.toLowerCase() != sufemail[1].toLowerCase() && this.state.tab === 'educator') {
                    this.props.openDialog("Email must be ***@" + school.email_c_suffix_university + " if you want to register account for " + school.name_university);
                    return;
                }
            }
        }

        if (foundschool == false) {
            this.props.openDialog("School not found! Please try again.");
            return;
        }
        this.state.user.disabled = true;
        $.ajax({
            url: this.props.url,
            dataType: 'json',
            type: 'POST',
            data: user,
            success: function (data) {
                if (data.status == 1) {
                    // this.props.openDialog(data.message);
                    //this.props.openDialog("Your account has been created! Please check your email for verification!");
                    this.props.openDialog("Hi "+this.state.user.lname+", Please verify your email address by clicking the link sent to "+this.state.user.email);
                    this.setState({user: {fname: '', lname: '', email: '', pass: '', school: 0, disabled: false}});
                    setTimeout(function(){
                        window.location.replace("/home");
                    }, 10000);

                } else {
                    this.props.openDialog(data.message);
                    //console.log('alert here');
                }
                this.state.user.disabled = false;

            }.bind(this),
            error: function (xhr, status, err) {
                console.error(this.props.url, status, err.toString());
                this.state.user.disabled = false;
            }.bind(this)
        });
        //user[propertyName] = event.target.value;
    };

    // begin of employer
    handleEChange = (propertyName, event) => {
        const employer = this.state.employer;
        employer[propertyName] = event.target.value;
        this.setState({employer: employer});
    };

    getECompOptions = (input) => {
        if (input.length == 0 || input.length < 2) {
            //this.setState({location:""});
            this.setState({comOpsE: this.state.comOpsE});
        }
        else {
            var data = new FormData();
            data.append('search', input);
            axios.post('/code/apis.php?api=searchCompany', data, {
                progress: (progressEvent) => {}
            })
                .then(response => {
                    if (response.data.status == 1) {
                        var array = [];
                        var i = 1;
                        for (var item of response.data.data) {
                            var name = item.name_company;

                            var img = '';
                            if (item.id_file_company > 0) {
                                img = item.file.link_file;
                            }
                            var des = item.city_company;
                            array.push({value: item.id_company, label: name, des: des, icon: img});
                            i++;
                        }
                        if (array.length == 0) {
                            array.push({value: 0, label: input, des: "Add New Company", icon: ""});
                        }

                        this.setState({comOpsE: array});
                    }

                    return response;
                }).catch(error => {
            });

        }
    }

    onSelectCompany = (item) => {
        var employer = this.state.employer;
        if (item.value == 0) {
            employer.name_company = item.label;
            employer.company = 0;
        } else {
            employer.company = item.value;
            employer.name_company = "";
        }
        this.setState({employer: employer});

    }

    handleTabClick = (tab) => {
        this.setState({tab: tab});
    }

    handleESubmit = (event) => {
        event.preventDefault();
        const employer = this.state.employer;
        employer['api'] = 'esignup';
        if (this.props.location !== undefined) {
            employer['jobs'] = this.props.location.state;
        }

        const email = this.state.employer.email.trim();
        const pass = this.state.employer.pass.trim().length;

        if (this.state.employer.email.trim().length == 0 || this.state.employer.pass.trim().length == 0 || this.state.employer.phone.trim().length == 0 || this.state.employer.fname.trim().length == 0 || this.state.employer.lname.trim().length == 0 || this.state.employer.disabled) {
            return;
        }
        if (this.state.employer.company == 0 && this.state.employer.name_company.length == 0) {
			//this.props.openDialog("Please select your company");
            return;
        }

        this.state.employer.disabled = true;
        $.ajax({
            url: this.props.url,
            dataType: 'json',
            type: 'POST',
            data: employer,
            success: function (data) {
                console.log(data);
                if (data.status == 1) {
                    // this.props.openDialog(data.message);
                    //this.props.openDialog("Your account has been created! Please check your email for verification!");
                    this.setState({
                        employer: {
                            fname: '',
                            lname: '',
                            email: '',
                            pass: '',
                            company: 0,
                            name_company: "",
                            phone: "",
                            disabled: false
                        }
                    })
                    this.props.openDialog("Hi "+this.state.employer.lname+", Please verify your email address by clicking the link sent to "+this.state.employer.email);
                    setTimeout(function(){
                        window.location.replace("/home");
                    }, 10000);
                }
                else {
                    this.props.openDialog(data.message);
                    //console.log('alert here');
                }
                this.state.employer.disabled = false;

            }.bind(this),
            error: function (xhr, status, err) {
                console.error(this.props.url, status, err.toString());
                this.state.employer.disabled = false;
            }.bind(this)
        });
        //user[propertyName] = event.target.value;
    };

    // begin render
    renderEmployerPc = () => {
        return (
            <form onSubmit={this.handleESubmit}>
                <div
                    className={this.props.frm == 'signup' ? "link_signup splash_signup pc-signup" : "splash_signup"}>
                    <h3>
                        <strong>
                            GET STARTED
                        </strong>
                        <br/>
                        IT'S FREE!
                    </h3>
                    <div className={this.props.noSwitch != undefined ? "hide-el" : ""}>
                        <a className={this.state.tab === 'student' ? "btn_v btn_invite student border active" : "btn_v btn_invite student border"} onClick={this.handleTabClick.bind(this, 'student')}>Student </a>
                        <a className={this.state.tab === 'educator' ? "hide-el btn_v btn_invite educator border active" : "hide-el btn_v btn_invite educator border"} onClick={this.handleTabClick.bind(this, 'educator')}>Educator </a>
                        <a className={this.state.tab === 'business' ? "btn_v btn_invite active" : "btn_v btn_invite"} onClick={this.handleTabClick.bind(this, 'business')}>Company</a>
                    </div>
                    <div className={"splash_esignup business-signup"}>
                        <div className="content">
                            <div className="field_row">
                                <div className="right_field">
                                    <div className="div_49_left">
                                        <input className="input_text" name={"efn"} onChange={this.handleEChange.bind(this, 'fname')}
                                               value={this.state.employer.fname} required type="text"
                                               placeholder="First Name"/>
                                    </div>
                                    <div className="div_49_right">
                                        <input className="input_text" name={"eln"} onChange={this.handleEChange.bind(this, 'lname')}
                                               value={this.state.employer.lname} required type="text"
                                               placeholder="Last Name"/>
                                    </div>
                                </div>
                            </div>
                            <div className="field_row">
                                <div className="right_field">
                                    <Select
                                        value={this.state.employer.company}
                                        onChange={this.onSelectCompany.bind(this)}
                                        placeholder="Company Name"
                                        options={this.state.comOpsE}
                                        optionRenderer={this.optionRenderer}
                                        noResultsText="No company found"
                                        searchPromptText="Enter at least 2 characters"
                                        onInputChange={this.getECompOptions.bind(this)}
                                        clearable={false}
                                        searchable={true}
                                        allowCreate={true}
										required
                                        className={"esignup-select"}
                                    />
                                </div>
                            </div>
                            <div className="field_row">
                                <div className="right_field">
                                    <input className="input_text" name={"ephone"} onChange={this.handleEChange.bind(this, 'phone')}
                                           value={this.state.employer.phone} required type="phone"
                                           placeholder="Phone"/>
                                </div>
                            </div>
                            <div className="field_row">
                                <div className="right_field">
                                    <input className="input_text" name={"email"} onChange={this.handleEChange.bind(this, 'email')}
                                           value={this.state.employer.email} required type="email"
                                           placeholder="Work Email"/>
                                </div>
                            </div>
                            <div className="field_row">
                                <div className="right_field">
                                    <input className="input_text" name={"epassword"} onChange={this.handleEChange.bind(this, 'pass')}
                                           value={this.state.employer.pass} required type="password"
                                           placeholder="Password"/>
                                </div>
                            </div>

                        </div>
                        <div className="text01">
                            <div className="chkbox">
                                <input type="checkbox" tabIndex="3" id="keepLogin" name="lremember"/>
                            </div>
                            <span className="labbox">
                            I confirm I represent HR, Recruiting, Marketing, PR, or am an executive at my
                            company and I agree to Versity's <Link to="/terms">Term of Service</Link> and <Link
                                to="/privacy">Privacy Policy</Link> on behalf of my company.
                        </span>
                        </div>
                        <div className="content">
                            <div className="field_row">
                                <div className="row">
                                    <input className="btn_v btn_confirm" disabled={this.state.employer.disabled}
                                           type="submit"
                                           value="Unlock Free Company Page"/>
                                </div>
                                <div className="row">
                                    <p className="text02">Already have an account? <Link to="/signin">Sign In!</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        )
    }

    renderEducatorPC = () => {
        return (
            <form onSubmit={this.handleSubmit}>
                <div
                    className={this.props.frm == 'signup' ? "link_signup splash_signup pc-signup" : "splash_signup"}>
                    <h3>
                        <strong>
                            GET STARTED
                        </strong>
                        <br/>
                        IT'S FREE!
                    </h3>
                    <div className={this.props.noSwitch != undefined ? "hide-el" : ""}>
                        <a className={this.state.tab === 'student' ? "btn_v btn_invite student border active" : "btn_v btn_invite student border"} onClick={this.handleTabClick.bind(this, 'student')}>Student </a>
                        <a className={this.state.tab === 'educator' ? "hide-el btn_v btn_invite educator border active" : "hide-el btn_v btn_invite educator border"} onClick={this.handleTabClick.bind(this, 'educator')}>Educator </a>
                        <a className={this.state.tab === 'business' ? "btn_v btn_invite active" : "btn_v btn_invite"} onClick={this.handleTabClick.bind(this, 'business')}>Company</a>
                    </div>
                    <div className={"student-signup"}>
                        <input className="ip_firstname" name={"sfn"} onChange={this.handleChange.bind(this, 'fname')}
                               value={this.state.user.fname} required type="text" placeholder="First Name"/>
                        <input className="ip_lastname" name={"sln"} onChange={this.handleChange.bind(this, 'lname')}
                               value={this.state.user.lname} required type="text" placeholder="Last Name"/>
                        <div className={"home-school"}>
                            <Select
                                value={this.state.user.school}
                                onChange={this.onSelectSchool.bind(this)}
                                placeholder="Your school"
                                options={this.state.comOps}
                                optionRenderer={this.optionRenderer}
                                noResultsText="No school found"
                                searchPromptText="Enter at least 2 characters"
                                onInputChange={this.getCompOptions.bind(this)}
                                clearable={false}
                                searchable={true}
                                allowCreate={true}
								required
                                className={"esignup-select"}
                            />
                        </div>
                        <input className="ip_email" name={"semail"} onChange={this.handleChange.bind(this, 'email')}
                               value={this.state.user.email} required type="email"
                               placeholder="Faculty email (must end in .edu)"/>
                        <input className="ip_pass" name={"spassword"} onChange={this.handleChange.bind(this, 'pass')}
                               value={this.state.user.pass} required type="password" placeholder="Password"/>
                        <p className="text01">
                            By clicking Sign Up, you agree to our <Link to="/terms">Terms</Link>, <Link to="/privacy">Data
                            Policy</Link> and <Link to="/cookies">Cookies Policy</Link></p>
                        <input className="ip_join" name="fsignup" disabled={this.state.user.disabled} type="submit"
                               value="SIGN UP"/>
                        {this.props.frm == 'signup' ?
                            <p className="account_box_backs">Already have an account? <Link to="/signin">Sign In!</Link>
                            </p>
                            : ""}
                    </div>
                </div>
            </form>
        )

    }

    renderStudentPC = () => {
        return (
            <form onSubmit={this.handleSubmit}>
                <div
                    className={this.props.frm == 'signup' ? "link_signup splash_signup pc-signup" : "splash_signup"}>
                    <h3>
                        <strong>
                            GET STARTED
                        </strong>
                        <br/>
                        IT'S FREE!
                    </h3>
                    <div className={this.props.noSwitch != undefined ? "hide-el" : ""}>
                        <a className={this.state.tab === 'student' ? "btn_v btn_invite student border active" : "btn_v btn_invite student border"} onClick={this.handleTabClick.bind(this, 'student')}>Student </a>
                        <a className={this.state.tab === 'educator' ? "hide-el btn_v btn_invite educator border active" : "hide-el btn_v btn_invite educator border"} onClick={this.handleTabClick.bind(this, 'educator')}>Educator </a>
                        <a className={this.state.tab === 'business' ? "btn_v btn_invite active" : "btn_v btn_invite"} onClick={this.handleTabClick.bind(this, 'business')}>Company</a>
                    </div>
                    <div className={"student-signup"}>
                        <input className="ip_firstname" name={"sfn"} onChange={this.handleChange.bind(this, 'fname')}
                               value={this.state.user.fname} required type="text" placeholder="First Name"/>
                        <input className="ip_lastname" name={"sln"} onChange={this.handleChange.bind(this, 'lname')}
                               value={this.state.user.lname} required type="text" placeholder="Last Name"/>
                        <div className={"home-school"}>
                            <Select
                                value={this.state.user.school}
                                onChange={this.onSelectSchool.bind(this)}
                                placeholder="Your school"
                                options={this.state.comOps}
                                optionRenderer={this.optionRenderer}
                                noResultsText="No school found"
                                searchPromptText="Enter at least 2 characters"
                                onInputChange={this.getCompOptions.bind(this)}
                                clearable={false}
                                searchable={true}
                                allowCreate={true}
								required
                                className={"esignup-select"}
                            />
                        </div>
                        <input className="ip_email" name={"semail"} onChange={this.handleChange.bind(this, 'email')}
                               value={this.state.user.email} required type="email"
                               placeholder="College email (must end in .edu)"/>
                        <input className="ip_pass" name={"spassword"} onChange={this.handleChange.bind(this, 'pass')}
                               value={this.state.user.pass} required type="password" placeholder="Password"/>
                        <p className="text01">
                            By clicking Sign Up, you agree to our <Link to="/terms">Terms</Link>, <Link to="/privacy">Data
                            Policy</Link> and <Link to="/cookies">Cookies Policy</Link></p>
                        <input className="ip_join" name="fsignup" disabled={this.state.user.disabled} type="submit"
                               value="SIGN UP"/>
                        {this.props.frm == 'signup' ?
                            <p className="account_box_backs">Already have an account? <Link to="/signin">Sign In!</Link>
                            </p>
                            : ""}
                    </div>
                </div>
            </form>
        )

    }

    renderEmployerMobile = () => {
        return (
            <form onSubmit={this.handleESubmit}>
                <div className="account_box_wrappers">
                    <div className={"head"}>
                        <div className={"content"}>
                            <h3>Connect to opportunity</h3>
                            <small>Join Versity now. It’s free!</small>

                            <div className={this.props.noSwitch != undefined ? "hide-el" : ""}>
                                <a className={this.state.tab === 'student' ? "btn_v btn_switch student border active" : "btn_v btn_invite student border"} onClick={this.handleTabClick.bind(this, 'student')}>Student </a>
                                <a className={this.state.tab === 'educator' ? "hide-el btn_v btn_switch educator border active" : "hide-el btn_v btn_invite educator border"} onClick={this.handleTabClick.bind(this, 'educator')}>Educator </a>
                                <a className={this.state.tab === 'business' ? "btn_v btn_switch active" : "btn_v btn_invite"} onClick={this.handleTabClick.bind(this, 'business')}>Company</a>
                            </div>

                            <input
                                className={"form-control input-lg"}
                                onChange={this.handleEChange.bind(this, 'fname')}
                                value={this.state.employer.fname}
                                required
                                type="text"
                                placeholder="First Name"/>
                            <input
                                className={"form-control input-lg second"}
                                onChange={this.handleEChange.bind(this, 'lname')}
                                value={this.state.employer.lname}
                                required
                                type="text"
                                placeholder="Last Name"/>
                        </div>
                    </div>
                    <div className={"bottom"}>
                        <div className={"content"}>
                            <div className="home-school">
                                <Select
                                    value={this.state.employer.company}
                                    onChange={this.onSelectCompany.bind(this)}
                                    placeholder="Company Name"
                                    options={this.state.comOpsE}
                                    optionRenderer={this.optionRenderer}
                                    noResultsText="No company found"
                                    searchPromptText="Enter at least 2 characters"
                                    onInputChange={this.getECompOptions.bind(this)}
                                    clearable={false}
                                    searchable={true}
                                    allowCreate={true}
									required
                                    className={"esignup-select"}
                                />
                            </div>
                            <input
                                className={"form-control input-lg"}
                                onChange={this.handleEChange.bind(this, 'phone')}
                                value={this.state.employer.phone}
                                required
                                type="phone"
                                placeholder="Phone"/>
                            <input
                                className={"form-control input-lg"}
                                onChange={this.handleEChange.bind(this, 'email')}
                                value={this.state.employer.email}
                                required
                                type="email"
                                placeholder="Work Email"/>
                            <input
                                className={"form-control input-lg"}
                                onChange={this.handleEChange.bind(this, 'pass')}
                                value={this.state.employer.pass}
                                required
                                type="password"
                                placeholder="Password"/>
                            <div className="text01">
                                <div className="chkbox">
                                    <input type="checkbox" tabIndex="3" id="keepLogin" name="lremember"/>
                                </div>
                                <span className="labbox elabbox">
                                    I confirm I represent HR, Recruiting, Marketing, PR, or am an executive at my company and I agree to Versity's
                                    <Link to="/terms">Terms of Service</Link>, <Link to="/privacy">Privacy Policy</Link> and <Link to="/cookies">Cookie Policy</Link> on behalf of my company.
                                </span>
                            </div>
                            <input
                                className={"btn btn-lg btn-primary btn-block"}
                                disabled={this.state.employer.disabled}
                                type="submit"
                                value="Unlock Free Company Page"/>
                            <p>Already have an account? <Link className={"btn04"} to="/signin">Sign In!</Link></p>

                            <div className={"footerClear"}>&nbsp;</div>
                            <FooterComponent/>
                        </div>
                    </div>
                </div>
            </form>
        )
    }

    renderEducatorMobile = () => {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className="account_box_wrappers">
                    <div className={"head"}>
                        <div className={"content"}>
                            <h3>Connect to opportunity</h3>
                            <small>Join Versity now. It’s free!</small>

                            <div className={this.props.noSwitch != undefined ? "hide-el" : ""}>
                                <a className={this.state.tab === 'student' ? "btn_v btn_switch student border active" : "btn_v btn_invite student border"} onClick={this.handleTabClick.bind(this, 'student')}>Student </a>
                                <a className={this.state.tab === 'educator' ? "hide-el btn_v btn_switch educator border active" : "hide-el btn_v btn_invite educator border"} onClick={this.handleTabClick.bind(this, 'educator')}>Educator </a>
                                <a className={this.state.tab === 'business' ? "btn_v btn_switch active" : "btn_v btn_invite"} onClick={this.handleTabClick.bind(this, 'business')}>Company</a>
                            </div>

                            <input
                                className={"form-control input-lg"}
                                onChange={this.handleChange.bind(this, 'fname')}
                                value={this.state.user.fname}
                                required
                                type="text"
                                placeholder="First Name"/>
                        </div>
                    </div>
                    <div className={"bottom"}>
                        <div className={"content"}>
                            <input
                                className="form-control input-lg"
                                onChange={this.handleChange.bind(this, 'lname')}
                                value={this.state.user.lname}
                                required
                                type="text"
                                placeholder="Last Name"/>
                            <div className={"home-school"}>
                                <Select
                                    value={this.state.user.school}
                                    onChange={this.onSelectSchool.bind(this)}
                                    placeholder="School"
                                    options={this.state.comOps}
                                    optionRenderer={this.optionRenderer}
                                    noResultsText="No school found"
                                    searchPromptText="Enter at least 2 characters"
                                    onInputChange={this.getCompOptions.bind(this)}
                                    clearable={false}
                                    searchable={true}
                                    allowCreate={true}
									required
                                    className={"esignup-select"}
                                />
                            </div>
                            <input
                                className="form-control input-lg"
                                onChange={this.handleChange.bind(this, 'email')}
                                value={this.state.user.email}
                                required
                                type="email"
                                placeholder="Email"/>
                            <input
                                className="form-control input-lg"
                                onChange={this.handleChange.bind(this, 'pass')}
                                value={this.state.user.pass}
                                required
                                type="password"
                                placeholder="Password"/>
                            <input
                                className="btn btn-lg btn-primary btn-block"
                                disabled={this.state.user.disabled}
                                type="submit" value="Join now"/>
                            <p className={"policy"}>By clicking Join now, you agree to the Versity User Agreement,
                                Privacy Policy, and Cookie Policy</p>
                            <p className="account_box_backs">Already have an account? <Link to="/signin">Sign
                                In!</Link></p>
                        </div>
                    </div>
                </div>
            </form>
        )
    }

    renderStudentMobile = () => {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className="account_box_wrappers">
                    <div className={"head"}>
                        <div className={"content"}>
                            <h3>Connect to opportunity</h3>
                            <small>Join Versity now. It’s free!</small>

                            <div className={this.props.noSwitch != undefined ? "hide-el" : ""}>
                                <a className={this.state.tab === 'student' ? "btn_v btn_switch student border active" : "btn_v btn_invite student border"} onClick={this.handleTabClick.bind(this, 'student')}>Student </a>
                                <a className={this.state.tab === 'educator' ? "hide-el btn_v btn_switch educator border active" : "hide-el btn_v btn_invite educator border"} onClick={this.handleTabClick.bind(this, 'educator')}>Educator </a>
                                <a className={this.state.tab === 'business' ? "btn_v btn_switch active" : "btn_v btn_invite"} onClick={this.handleTabClick.bind(this, 'business')}>Company</a>
                            </div>

                            <input
                                className={"form-control input-lg"}
                                onChange={this.handleChange.bind(this, 'fname')}
                                value={this.state.user.fname}
                                required
                                type="text"
                                placeholder="First Name"/>
                        </div>
                    </div>
                    <div className={"bottom"}>
                        <div className={"content"}>
                            <input
                                className="form-control input-lg"
                                onChange={this.handleChange.bind(this, 'lname')}
                                value={this.state.user.lname}
                                required
                                type="text"
                                placeholder="Last Name"/>
                            <div className={"home-school"}>
                                <Select
                                    value={this.state.user.school}
                                    onChange={this.onSelectSchool.bind(this)}
                                    placeholder="School"
                                    options={this.state.comOps}
                                    optionRenderer={this.optionRenderer}
                                    noResultsText="No school found"
                                    searchPromptText="Enter at least 2 characters"
                                    onInputChange={this.getCompOptions.bind(this)}
                                    clearable={false}
                                    searchable={true}
                                    allowCreate={true}
									required
                                    className={"esignup-select"}
                                />
                            </div>
                            <input
                                className="form-control input-lg"
                                onChange={this.handleChange.bind(this, 'email')}
                                value={this.state.user.email}
                                required
                                type="email"
                                placeholder="Email"/>
                            <input
                                className="form-control input-lg"
                                onChange={this.handleChange.bind(this, 'pass')}
                                value={this.state.user.pass}
                                required
                                type="password"
                                placeholder="Password"/>
                            <input
                                className="btn btn-lg btn-primary btn-block"
                                disabled={this.state.user.disabled}
                                type="submit" value="Join now"/>
                            <p className={"policy"}>By clicking Join now, you agree to the Versity User Agreement,
                                Privacy Policy, and Cookie Policy</p>
                            <p className="account_box_backs">Already have an account? <Link to="/signin">Sign
                                In!</Link></p>
                        </div>
                    </div>
                </div>
            </form>
        )
    }

    render() {
        if (this.props.isMobile == 1) {
            if (this.state.tab === 'student') {
                return this.renderStudentMobile()
            }
            else if (this.state.tab === 'educator') {
                return this.renderEducatorMobile()
            }
            else {
                return this.renderEmployerMobile()
            }
        }
        else {
            if (this.state.tab === 'student') {
                return this.renderStudentPC()
            }
            else if (this.state.tab === 'educator') {
                return this.renderEducatorPC()
            }
            else {
                return this.renderEmployerPc()
            }
        }
    }
}
Splash_Signup.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};
export default (withRouter(Splash_Signup));



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/splash_signup.js
 **/